import anime from "animejs";

function checkStickyLogoAnimation() {
    const animationStartScaleLogoElements = anime({
        targets: '#svgLogo__bg, #svgLogo__text,#svgLogo__beanleft,#svgLogo__beanright',
        scale: 0,
        opacity: 0,
        autoplay: false
    });

    const animationStartOpacityLogoBg = anime({
        targets: '#svgLogo__bgouter',
        translateY: -27,
        scale: 0.7,
        easing: "easeOutExpo",
        duration: 300,
        autoplay: false
    });

    const animationStartPositionLogoSheep = anime({
        targets: '#svgLogo__bginner,#svgLogo__sheep',
        translateY: -27,
        scale: 1,
        easing: "easeOutExpo",
        duration: 300,
        autoplay: false
    });

    const animationReverseScaleLogoElements = anime({
        targets: '#svgLogo__bg, #svgLogo__text,#svgLogo__beanleft,#svgLogo__beanright',
        scale: 1,
        opacity: 1,
        autoplay: false
    });

    const animationReverseOpacityLogoBg = anime({
        targets: '#svgLogo__bgouter',
        translateY: 0,
        scale: 1,
        easing: "easeOutExpo",
        duration: 300,
        autoplay: false
    });

    const animationReversePositionLogoSheep = anime({
        targets: '#svgLogo__bginner,#svgLogo__sheep',
        translateY: 0,
        easing: "easeOutExpo",
        duration: 300,
        autoplay: false
    });

    let startPosition = 100;

    if(window.scrollY >= startPosition){
        animationStartScaleLogoElements.restart();
        animationStartOpacityLogoBg.restart();
        animationStartPositionLogoSheep.restart();
    }else{
        animationReverseScaleLogoElements.restart();
        animationReverseOpacityLogoBg.restart();
        animationReversePositionLogoSheep.restart();
    }
}

function freakySheepAnimation(onlyEyes= false,callback = ()=>{}) {
    const rotateEyeRight = anime.timeline({
        targets: "#svgLogo__eyeright",
        easing: 'linear',
        duration: 100,
        loop: 3
    }).add({
        translateX: "1%"
    })
        .add({
            translateX: "-3.5%"
        })
        .add({
            translateX: "0"
        });

    const rotateEyeLeft = anime.timeline({
        targets: "#svgLogo__eyeleft",
        easing: 'linear',
        duration: 150,
        autoplay: false
    }).add({
        translateX: "4.7%",
        translateY: "-2%",
    })
        .add({
            translateX: "3%",
            translateY: "-2%",
            scale: 1.3
        })
        .add({
            translateX: "3.8%",
            translateY: "0.9%",
            scale: 1.1
        })
        .add({
            translateX: "4.5%",
            translateY: "-3%",
            scale: 1
        })
        .add({
            translateX: "-2.1%",
            translateY: "0"
        })
        .add({
            translateX: "3%",
            translateY: "1.8%"
        })
        .add({
            translateX: "6.2%",
            translateY: "-6%",
            scale: 1.3
        })
        .add({
            translateX: "0",
            translateY: "0",
            scale: 1
        });

    const tlText = anime.timeline({
        targets: '#svgLogo__text',
        easing: 'easeOutElastic(2,2)',
        duration: 100,
        autoplay: false,
        complete: function () {
            tlLash.restart();
        }
    }).add({
        rotate: 2,
    })
        .add({
            rotate: -2,
        })
        .add({
            rotate: 2,
        })
        .add({
            rotate: -2,
        })
        .add({
            rotate: 0,
        });

    const tlLash = anime.timeline({
        targets: '#svgLogo__eyelashright',
        duration: 120,
        easing: "easeOutElastic(2,2)",
        loop: 2,
        autoplay: false,
        complete: callback
    }).add({
        translateY: "-1%",
    })
        .add({
            translateY: "0%",
        });

    if(onlyEyes){
        rotateEyeRight.restart();
        tlLash.restart();
    }else{
        const scaleSheep = anime.timeline({
            targets: '#svgLogo__sheep',
            easing: "easeOutElastic(2,2)",
            duration: 300,
            complete: function () {
                tlText.restart();
            }
        }).add({
            scale: 1.2
        })
            .add({
                scale: 1
            });
    }
    rotateEyeLeft.restart();
}

function changeBackgroundColor(){
    if(document.querySelector("product-info.has-background-color") !== null){
        let backgroundcolor = document.querySelector("product-info.has-background-color").dataset.backgroundColor;

        anime({
            targets: "#svgLogo__bginnercolor",
            fill: backgroundcolor
        });
    }
}

function setHeightOfAnimationWrapper(wrapper = "#animatedSheep", secondsToScroll = 6,offset = 0){
    if ($(wrapper).find(".animatedSheep__section").length > 0) {
        $(wrapper).find(".animatedSheep__section").pinBox({
            Top : offset + "px",
            Container : wrapper,
            MinWidth : '1px'
        });
        var heightWrapper = secondsToScroll * $('.animatedSheep__section').outerHeight();
        $('#animatedSheep').outerHeight(heightWrapper);
    }
}

export function initSheepLogo(){
    checkStickyLogoAnimation();

    if(!document.querySelector('.header__heading-logo-wrapper')){
        return;
    }

    document.querySelector('.header__heading-logo-wrapper').addEventListener("click",function (e) {
        let headerLink = e.currentTarget.getAttribute("href");
        e.preventDefault();
        freakySheepAnimation(false,()=>{
            window.location.href = headerLink;
        });
    });
    changeBackgroundColor();
    freakySheepAnimation();

    setInterval(function(){ freakySheepAnimation(true) }, 8000);

    window.addEventListener("scroll",function () {
        checkStickyLogoAnimation();
    });
    window.addEventListener("resize", function () {
        checkStickyLogoAnimation();
    });
    window.addEventListener("orientationchange", function () {
        checkStickyLogoAnimation();
    });
}